import { create } from 'zustand';
import type {
  KPI,
  SubjectProgress,
  ActiveExam,
  StudyPoint,
  TopicAccuracy,
  Recommendation,
} from '../lib/types/dashboard';

type State = {
  loading: boolean;
  kpi?: KPI;
  activeExam?: ActiveExam;
  subjects: SubjectProgress[];
  practiceTime: StudyPoint[];
  topicAccuracy: TopicAccuracy[];
  recommendations: Recommendation[];
  recent: { id: string; title: string; score: number; date: string; durationMin: number }[];
  fetch: () => Promise<void>;
};

export const useDashboardStore = create<State>(set => ({
  loading: true,
  subjects: [],
  practiceTime: [],
  topicAccuracy: [],
  recommendations: [],
  recent: [],
  fetch: async () => {
    set({ loading: true });
    await new Promise(r => setTimeout(r, 300));
    set({
      loading: false,
      kpi: { totalExams: 12, averageScore: 85, studyHours: 24, bestScore: 93, streakDays: 7 },
      activeExam: {
        id: 'ae1',
        subject: 'Toán',
        title: 'V-SAT Toán - Đại số nâng cao',
        answered: 13,
        total: 20,
        etaMin: 15,
      },
      subjects: [
        { id: 'math', name: 'Toán', progressPct: 85, trend: 'up', level: 'Strong' },
        { id: 'eng', name: 'Tiếng Anh', progressPct: 90, trend: 'up', level: 'Strong' },
        { id: 'sci', name: 'Khoa học', progressPct: 68, trend: 'flat', level: 'Average' },
        { id: 'soc', name: 'Xã hội', progressPct: 60, trend: 'down', level: 'Weak' },
      ],
      practiceTime: Array.from({ length: 14 }, (_, i) => ({
        date: new Date(Date.now() - (13 - i) * 864e5).toISOString(),
        minutes: Math.round(Math.random() * 90 + 30), // 30-120 minutes practice time
      })),
      topicAccuracy: [
        { topic: 'Đại số', accuracy: 82 },
        { topic: 'Hình học', accuracy: 76 },
        { topic: 'Xác suất', accuracy: 64 },
        { topic: 'Văn học', accuracy: 91 },
      ],
      recommendations: [
        {
          id: 'rec1',
          title: 'Luyện tập Xã hội - Lịch sử',
          subtitle: 'Điểm thấp nhất (60%)',
          estMin: 45,
          cta: 'start',
        },
        {
          id: 'rec2',
          title: 'Ôn lại Khoa học - Vật lí',
          subtitle: 'Cần cải thiện độ chính xác',
          estMin: 30,
          cta: 'review',
        },
      ],
      recent: [
        {
          id: 'r1',
          title: 'V-SAT Toán - Cơ bản',
          score: 87,
          date: new Date().toISOString(),
          durationMin: 42,
        },
        {
          id: 'r2',
          title: 'V-SAT Tiếng Anh - Đọc hiểu',
          score: 88,
          date: new Date(Date.now() - 864e5).toISOString(),
          durationMin: 38,
        },
        {
          id: 'r3',
          title: 'V-SAT Khoa học - Tổng hợp',
          score: 72,
          date: new Date(Date.now() - 2 * 864e5).toISOString(),
          durationMin: 45,
        },
      ],
    });
  },
}));
